// ** Third Party
import { Controller, useController } from "react-hook-form";
// ** Custom Components
// import { selectThemeColors } from "@helpers/utils";
// ** Reactstrap
import RawSelectField from "./raw-select";
import get from "lodash/get";

const Select = (props) => {

    const {
        control,
        errors,
        name,
        id
    } = props;
    
    const {
        field: { onChange, value, onBlur }
    } = useController({
        name,
        control
    });

    const message = get(errors, `${name}.message`) || get(errors, `${id}.message`);
    const isInvalid = Boolean(get(errors, name) || get(errors, id));
    return (
     
        <Controller
            name={name}
            control={control}
            render={() => {
                return (
                    <RawSelectField
                        onChange={onChange}
                        value={value}
                        {...props}
                        message={message}
                        isInvalid={isInvalid}
                        onBlur={onBlur}/>
                );
            }}/>
    );
};

export default Select;
